var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopContactPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_3410_670)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3410_670",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3410_670",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3410_670",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUBJREFUSA3tlS9OxFAQhz+BQCBIQHAEBAKJ4BgcAoFAIhAcAMFFICQILAncAbkCBAkXIEFAv8eb5PHSpd1X/hgm2Z12OvP7prPdKfyyrQD7HfPkGz6HwFrd/xXwApxOBFivzk0NeAXOgdsO4t20mHXWXwDqfbI3YAk4a4Ss5jrrNfXY7r5i5imQLn1A7oGNfD7kzDM/xM1Pes/FzEuACce5aAgS4kdVF0mvFC2PI9enYQZsRqDyxh8A82obBbDIR1eRGhLiXu+z0QCL9zJkJyvt5nPj82whgCKK+Zs5Dv1X4uYvDLDIzp+yn9d5xJsAUTzG/wMGp/Q3I1oe7GtcgkszbdN0G7nmDrjujmP5TfG+Wy7VLQHrwMEEgFrRlOsjTaMECJxivVr+5d3hQW71ajz2decLx73fKlzWbfUBfjT2Dm/qh5je8DF4AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopContactPage);
export default __webpack_public_path__ + "static/media/envelop-contact-page.aa6dc9e87d2d3a38b893512822bdd512.svg";
export { ForwardRef as ReactComponent };